import React from 'react';

import styles from './LeftRegisterText.module.css';

const LeftRegisterText = () => (
  <ul className={styles.list}>
    <li>Unique deadlines automatically personalized and assigned to each potential buyer</li>
    <li>Integration with your email, webinar, and page builder software so your messaging is consistent</li>
    <li>Analytics reporting to show you how much money you're making from your campaigns</li>
    <li>Email countdown timers to match your web page timers</li>
    <li>Free 15 minute onboarding call</li>
  </ul>
);

export default LeftRegisterText;
